import { createGlobalStyle } from 'styled-components';

import { Color } from '~/src/atomic/obj.constants';

export const GlobalStyled = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  img {
    max-width: 100%;
  }
  body {
    margin: 0;
    background-color: ${Color.GrayXLight};
  }
  a {
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0.05);
    color: ${Color.Primary};
  }
`;
